import { cva } from 'class-variance-authority';
import { Flex, Text, Select } from '@nula/core-ui';
import styles from './retention-section.module.css';

export type RetentionSectionProps = {
  value: number | null;
  onChange: (v: number | null) => void;
  className?: string;
};

const root = cva(styles.root);

const RETENTION_OPTIONS = [
  { value: '30', label: '30 days' },
  { value: '60', label: '60 days' },
  { value: '90', label: '90 days' },
  { value: '180', label: '180 days' },
  { value: 'never', label: 'Never' },
];

function valueToOption(v: number | null): string {
  return v === null ? 'never' : String(v);
}

function optionToValue(v: string): number | null {
  return v === 'never' ? null : Number(v);
}

export function RetentionSection({ value, onChange, className }: RetentionSectionProps) {
  return (
    <Flex vertical className={root({ className })}>
      <Text size="sm" className={styles.label}>Audio retention</Text>
      <Text type="secondary" size="xs">
        How long to keep audio recordings before automatic deletion.
      </Text>
      <Select
        size="sm"
        options={RETENTION_OPTIONS}
        value={valueToOption(value)}
        onChange={(v) => onChange(optionToValue(v as string))}
        className={styles.select}
      />
    </Flex>
  );
}
